import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface SalesRepResponse {
    id?: number | null;
    name?: string | null;
    user_name?: string | null;
}

export const getAllSalesReps = async (): Promise<SalesRepResponse[]> => {
    try {
        const response: ApiResponse<SalesRepResponse[] | null> = (
            await apiClient.get("/sales_reps", {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data || [];
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to fetch sales representatives");
    }
};
